"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var StyledLink = _styledComponents.default.a.withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-cyqy0n-0"
})(["width:fit-content;cursor:pointer;color:", ";", ";:visited{color:", ";}"], _styles.colors.link.active, _styles.font.base.regular, _styles.colors.link.visited);
var Link = function Link(_ref) {
  var children = _ref.children,
    linkProps = _objectWithoutProperties(_ref, ["children"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, _objectSpread({}, linkProps, {
    children: children
  }));
};
Link.defaultProps = {};
var _default = exports.default = Link;